var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIMessages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 17.909 17.909 0 40 0s40 17.909 40 40-17.909 40-40 40S0 62.091 0 40z",
    fill: "url(#iMessages_svg__paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 38.562C15 26.642 26.251 17.98 40 18c13.749.02 25 8.643 25 20.562 0 11.92-12.202 20.563-25 20.563-2.1 0-4.427-.303-6.35-.447-1.925-.144-5.835 3.483-10.695 3.033 2.644-1.799 3.674-3.888 3.98-5.705C19.99 52.467 15 46.185 15 38.562z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "iMessages_svg__paint0_linear",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67FF81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01B41F"
  })))));
}
export default SvgIMessages;